
/**
 * Write legal T&C text.
 * @param {String} text 
 */
export const renderLegal = text => {
    document.querySelector('.legal').innerHTML = text;
}



/**
 * Set "Need Help?" Exits. Checks for all .help class assigned elements.
 * @param {String} url 
 */
export const setHelpUrl = url => {
    const doms = document.querySelectorAll('.help');
    doms.forEach(dom => {
        dom.href = url;
    })
}

/**
 * Set "Need Help?" Exits. Checks for all .help class assigned elements.
 * @param {String} url 
 */
export const setPrivacyPolicyUrl = url => {
    const doms = document.querySelectorAll('.privacy');
    doms.forEach(dom => {
        dom.href = url;
    })
}



/**
 * Set "Need Help?" Exits. Checks for all .help class assigned elements.
 * @param {String} url 
 */
export const setTermsUrl = url => {
    const doms = document.querySelectorAll('.terms');
    doms.forEach(dom => {
        dom.href = url;
    })
}